import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  TagsDashboardFetchParamsType,
  TagsDashboardLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';

const initialState = {filters: {} as TagsDashboardLocationParamsType};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setTagsFilters(state, action: PayloadAction<TagsDashboardFetchParamsType>) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {setTagsFilters} = tagsSlice.actions;

export const selectTagFilters = (
  state: DefaultRootState
): TagsDashboardLocationParamsType => pickBy(state.tags.filters);
